import type { MessagingSendMessageBodyType } from './messagingSendMessageBodyType';

export type MessagingSendMessageBody = {
  /** 메시지 내용 */
  content: string;
  /** 첨부된 URL 목록 */
  links?: string[];
  /** 미디어 ID 목록 */
  mediaIds?: number[];
  /** 메시지 타입 */
  type?: MessagingSendMessageBodyType;
};
